import React from 'react';
import { Modal, Row, Col, Skeleton } from 'antd';
import { SecondaryButton } from '../UI/Button/Button';
import QRSection from '../UI/QRSection/QRSection';
import appDownloadImage from '../../assets/images/app-download-modal.svg';
import './_custommodal.scss';

const AppDownloadModal = ({ visible, onClose }: { visible: boolean, onClose: () => void }) => {
  const [imageLoaded, setImageLoaded] = React.useState(false);

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      title={<div className="modal-title">Download App</div>}
      centered
      width={611}
      maskClosable={false}
      className="app-download-modal"
      footer={[
        <Row justify="end" key="footer">
          <SecondaryButton onClick={onClose}>CLOSE</SecondaryButton>
        </Row>
      ]}
    >
      <Row justify="center">
        <Col span={!imageLoaded ? 24 : undefined}>
          {!imageLoaded && (
            <Skeleton.Button active block style={{ height: '352px', borderRadius: '8px' }} />
          )}
          <img
            src={appDownloadImage}
            alt="Download App"
            style={{ width: '100%', display: imageLoaded ? 'block' : 'none' }}
            onLoad={() => setImageLoaded(true)}
          />
        </Col>
      </Row>
      <QRSection
        title="Take Your Benefits on the Go!"
        subtitle="Access your perks anytime with our app. Scan the QR code to download the app now."
      />
    </Modal>
  );
};

export default AppDownloadModal;